import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../../internal/Action.js";
import { Qualifier } from "../../../internal/qualifier/Qualifier.js";
/**
 * Enhances an image to its best visual quality with the Viesus Automatic Image Enhancement add-on.</br>
 * <b>Learn more:</b> {@link https://cloudinary.com/documentation/viesus_automatic_image_enhancement_addon|Viesus Automatic Image Enhancement.}
 * @memberOf Actions.Adjust
 */

var ViesusCorrectAdjustAction = /*#__PURE__*/function (_Action) {
  _inherits(ViesusCorrectAdjustAction, _Action);

  var _super = _createSuper(ViesusCorrectAdjustAction);

  function ViesusCorrectAdjustAction() {
    _classCallCheck(this, ViesusCorrectAdjustAction);

    return _super.apply(this, arguments);
  }

  _createClass(ViesusCorrectAdjustAction, [{
    key: "noRedEye",
    value:
    /**
     * @description Enhances the image without correcting for red eye.
     */
    function noRedEye() {
      this._noRedEye = true;
      return this;
    }
    /**
     * @description Applies saturation to the skin tones in the image.
     * @param level The saturation level. (Range: -100 to 100, Server default: 50).
     */

  }, {
    key: "skinSaturation",
    value: function skinSaturation(level) {
      this._skinSaturation = true;

      if (level) {
        this._skinSaturationLevel = level;
      }

      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var value = 'viesus_correct';

      if (this._noRedEye) {
        value += ':no_redeye';
      }

      if (this._skinSaturation) {
        value += ':skin_saturation';

        if (typeof this._skinSaturationLevel !== 'undefined') {
          value += "_".concat(this._skinSaturationLevel);
        }
      }

      this.addQualifier(new Qualifier('e', value));
    }
  }]);

  return ViesusCorrectAdjustAction;
}(Action);

export { ViesusCorrectAdjustAction };